import { render, staticRenderFns } from "./AddEmployes.vue?vue&type=template&id=8eea70ca&"
import script from "./AddEmployes.vue?vue&type=script&lang=js&"
export * from "./AddEmployes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports